import { ReplaySubject } from 'rxjs';

type ValuesOf<T> = T[keyof T];

export type ABTestTaskListType = keyof typeof abTestList;
export type HeaderMainGroupType = ValuesOf<{
  [K in keyof typeof abTestList]: typeof abTestList[K]['headerMainGroup'];
}>;
export type ABVariantsType = ValuesOf<{
  [K in keyof typeof abTestList]: ValuesOf<typeof abTestList[K]['abTestGroupIds']>;
}>;

export interface ABTestItem<K extends keyof typeof abTestList> {
  nameOfTask?: ABTestTaskListType;
  alias?: string;
  headerMainGroup: HeaderMainGroupType;
  abTestVariants: ABVariantsType[];
  abTestGroupIds: Record<keyof typeof abTestList[K]['abTestGroupIds'], ABVariantsType>;
  resolvedValue?: ABVariantsType;
  resolvedValue$?: ReplaySubject<ABVariantsType>;
  resolvedCookieValue?: ABVariantsType;
  syncOnAuth?: boolean;
  debug?: boolean;
};

export const AB_TEST_LIST: {
  [K in keyof typeof abTestList]: ABTestItem<K>;
} = {} as any;

export const abTestList = {
  'CUSTOM_FLOW': {
    alias: 'CUSTOM_FLOW',
    headerMainGroup: 'ID352',
    abTestGroupIds: {
      V1: 'ID352',
      V2: 'ID353',
    },
    syncOnAuth: true,
    debug: false,
  },
  'DEVBIT4785': {
    alias: 'DEVBIT4785',
    headerMainGroup: 'ID823',
    abTestGroupIds: {
      V1: 'ID823',
      V2: 'ID824',
    },
    syncOnAuth: true,
    debug: false,
  },
  'DEVBIT4802': {
    alias: 'DEVBIT4802',
    headerMainGroup: 'ID835',
    abTestGroupIds: {
      V1: 'ID835',
      V2: 'ID836',
    },
    syncOnAuth: true,
    debug: false,
  },
} as const;
